import React from 'react';
import { isLink, MinimalCard } from '@/lib/interface/stripe/BiddifyPaymentMethod';
import Image from 'next/image';
import mastercard from '@/public/modern_mastercard.svg';
import visa from '@/public/modern_visa.svg';
import amex from '@/public/american_express.png';
import link from '@/public/link.svg';
import { TokenizedPM } from '@/lib/interface/stripe/tokenizedCard';
import { Flex } from '@radix-ui/themes';

const CreditCardSelectImage = ({ card }: { card: TokenizedPM }) => {
  if (isLink(card)) {
    return (
      <Flex className="py-3" align="center">
        <Image src={link} alt="Link" width="45" />
      </Flex>
    )
  }

  switch (card.brand) {
    case 'mastercard':
      return <Image src={mastercard} alt="Mastercard" width="40" />
    case 'visa':
      return <Image src={visa} alt="Visa" width="40" />
    case 'amex':
      return <Image src={amex} alt="American Express" width="40" />
    default:
  }
}

export default CreditCardSelectImage
